import React from 'react'
import ClaimsBulkSidebarLayout from './components/ClaimsBulkSidebarLayout'
import BulkCancelBundleModal from './components/BulkCancelBundleModal'

export default function ClaimsBulkPage({ action = 'cancel' }) {
  return (
    <ClaimsBulkSidebarLayout>
      <BulkCancelBundleModal
        open={true}
        isInline={true}
        action={action}
        onClose={() => {}}
        onCompleted={() => {}}
      />
    </ClaimsBulkSidebarLayout>
  )
}
